import { io, Socket } from 'socket.io-client';

const MESSAGES_NAMESPACE = '/messages';

function getApiUrl(): string {
  return import.meta.env.VITE_API_URL || '';
}

export interface MessageSocketOptions {
  token: string;
  autoConnect?: boolean;
  reconnection?: boolean;
}

export function createMessageSocket(options: MessageSocketOptions): Socket {
  const { token, autoConnect = true, reconnection = true } = options;

  return io(`${getApiUrl()}${MESSAGES_NAMESPACE}`, {
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect,
    reconnection,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  });
}

export interface MessageSocketEvents {
  connected: { message: string; user: { id: string; role: string } };
  'message:new': {
    conversationId: string;
    type: string;
    title: string;
    senderName: string;
    priority: string;
  };
  'message:reply': {
    conversationId: string;
    replyId: string;
    senderId: string;
    senderName: string;
    content: Record<string, unknown>;
  };
  'message:read': {
    conversationId: string;
    recipientId: string;
  };
  'unread:count': {
    count: number;
  };
  error: { message: string };
}
